import { PlayoutService } from './../../../services/playout.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SapiService } from '../../../services/sapi.service';
import { BBPlayerAPI } from 'app/interfaces/bb-player-api';
import { Subscription } from 'rxjs';
import { WebSocketsService } from 'app/services/web-sockets.service';

@Component({
	selector: 'playout-details-appearance',
	templateUrl: './playout-details-appearance.component.html',
	styleUrls: ['./playout-details-appearance.component.scss'],
})
export class PlayoutDetailsAppearanceComponent implements OnInit, OnDestroy {
	@Input() playout: any;
	@Input() form: NgForm;
	@Input() usedColors: string[];
	@Input() playerApi: BBPlayerAPI;

	subscriptions = new Subscription();
	newUpload = false;

	playerIdOptions: any[] = [];
	skinGenerationOptions: any[] = [
		{
			label: this.translate.instant('DEFAULT'),
			value: '',
			default: true,
		},
		{
			// pre-2018
			label: 'Generation 6',
			value: 'g6',
		},
		{
			// 2018, Vue
			label: 'Generation 7',
			value: 'g7',
		},
		{
			// 2022, Svelte
			label: 'Generation 8',
			value: 'g8preview',
		},
	];
	maxWidthUnits = [{ label: 'px', value: 'px' }];

	constructor(
		public playoutService: PlayoutService,
		private sapiService: SapiService,
		private translate: TranslateService,
		private webSocketsService: WebSocketsService
	) {}

	ngOnInit() {
		this.sapiService.query('player').subscribe((data: any) => {
			if (data && data.items) {
				this.playerIdOptions = data.items.map((player: any) => ({
					label: player.name,
					value: player.id,
				}));
			}
		});
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	setUploaded(isUploaded: boolean) {
		this.newUpload = isUploaded;
	}

	changePlayoutLogo(id: string) {
		if (this.playout) {
			this.playout.logoId = id;
			this.form.form.markAsDirty();

			// trigger changedplayoutdata event for player review, null (removed) must be '' to reset in api
			if (!this.newUpload) {
				this.playerApi?.updatePlayout({ logoId: id === null ? '' : id });
			} else {
				// new img? wait till ready
				this.subscriptions.add(
					this.webSocketsService.subscribeToChannel('MediaClip').subscribe((websocketEvent: any) => {
						if (websocketEvent.payload && websocketEvent.payload.id === id) {
							if (websocketEvent.ev === 'ingest' && websocketEvent.status === 'success') {
								// for new img upload, reset to it's loaded after
								this.playerApi?.updatePlayout({ logoId: 'reset' });
								setTimeout(() => {
									this.playerApi?.updatePlayout({ logoId: id });
								}, 100);
							}
						}
					})
				);
				this.newUpload = false;
			}
		}
	}
}
